// So funktioniert's: while the section is pinned, scrolling opens the printed mailer box (3D, karton.css),
// the pack rises out front first and is torn open (image sequence on a canvas), steps 01–03 take turns
// and a jersey rises out.
(() => {
  const root = document.querySelector('.tear');
  if (!root || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const sticky = root.querySelector('.tear-sticky');
  const canvas = root.querySelector('.tear-canvas');
  const ctx = canvas.getContext('2d');
  const steps = [...root.querySelectorAll('.tear-step')];
  const visual = root.querySelector('.tear-visual');
  const badges = root.querySelector('.tear-badges');
  const box = root.querySelector('.tear-box');
  const narrow = matchMedia('(max-width: 850px)');
  const TEAR = 47;
  const frames = [];
  const clamp = v => Math.min(1, Math.max(0, v));
  let target = 0, shown = 0, drawn = -1, step = -1, running = false;

  root.classList.add('is-live');

  const load = () => {
    if (frames.length) return;
    for (let i = 0; i < TEAR; i++) {
      const img = new Image();
      img.decoding = 'async';
      img.onload = () => { if (i === frameAt(shown)) drawn = -1; };
      // Theme: flat asset names next to each other on the CDN (window.MP.assetBase).
      img.src = window.MP ? `${window.MP.assetBase}abriss-${String(i).padStart(2, '0')}.webp` : `assets/abriss/${String(i).padStart(2, '0')}.webp`;
      frames.push(img);
    }
  };
  // The torn strip fades out on its way up instead of being cut off at the frame edge.
  const fadeStrip = i => {
    const gone = clamp((i - 24) / 16);
    const g = ctx.createLinearGradient(0, 0, 0, 112);
    g.addColorStop(0, '#000');
    g.addColorStop(.5, `rgba(0,0,0,${gone})`);
    g.addColorStop(.9, `rgba(0,0,0,${gone})`);
    g.addColorStop(1, 'rgba(0,0,0,0)');
    ctx.globalCompositeOperation = 'destination-out';
    ctx.fillStyle = g;
    ctx.fillRect(0, 0, canvas.width, 112);
    ctx.globalCompositeOperation = 'source-over';
  };
  // Draw the wanted frame, or the closest earlier one that has arrived.
  const draw = index => {
    if (index === drawn) return;
    for (let i = index; i >= 0; i--) {
      const img = frames[i];
      if (img && img.complete && img.naturalWidth) {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        fadeStrip(i);
        drawn = i === index ? index : -1;
        root.classList.add('has-canvas');
        return;
      }
    }
  };

  // Scroll phases: 0–.3 box opens and the pack rises out, .3–.66 tear, .66–1 jersey.
  const introAt = p => clamp(p / .3);
  const tearAt = p => clamp((p - .3) / .34);
  const riseAt = p => clamp((p - .68) / .24);
  const frameAt = p => Math.round(tearAt(p) * (TEAR - 1));
  const ease = t => t < .5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
  // Box intro: the lid swings open, the front flap folds out over the front wall, then the side flaps lying
  // over the pack open; the pack stands up,
  // flies up out of the box, then settles at its tear-frame size while the box sinks away.
  const openBox = i => {
    const lid = ease(clamp((i - .16) / .24)) * 108;
    const front = ease(clamp((i - .34) / .16));
    const ears = ease(clamp((i - .5) / .16));
    const fly = ease(clamp((i - .66) / .18));
    const settle = ease(clamp((i - .84) / .16));
    const sink = ease(clamp((i - .8) / .2));
    // While the lid can still cover them, the closed flaps and the lying pack are 3D planes in the box.
    // Once the lid is up far enough they switch to the copies drawn in front of the lid, in one frame:
    // both layers line up, so a crossfade would only make them see-through.
    const handover = lid >= 59 ? 1 : 0;
    box.style.setProperty('--lid', lid.toFixed(2));
    box.style.setProperty('--ears', ears.toFixed(4));
    box.style.setProperty('--front', front.toFixed(4));
    box.style.setProperty('--front-o', handover);
    box.style.setProperty('--ears-o', handover);
    box.style.setProperty('--inner-o', (1 - handover).toFixed(3));
    box.style.setProperty('--floorpack-o', (1 - handover).toFixed(3));
    box.style.setProperty('--pack-o', handover.toFixed(3));
    box.style.setProperty('--pack-y', (25 - 51 * fly + 26 * settle).toFixed(2));
    box.style.setProperty('--pack-s', (.365 + .415 * fly + .22 * settle).toFixed(4));
    box.style.setProperty('--pack-rx', (64 * (1 - fly)).toFixed(2));
    box.classList.toggle('is-out', fly > .6);
    box.style.setProperty('--sink', (44 * sink).toFixed(2));
    box.style.setProperty('--box-o', (1 - sink).toFixed(3));
  };

  const measure = () => {
    const rect = root.getBoundingClientRect();
    const top = parseFloat(getComputedStyle(sticky).top) || 0;
    const travel = rect.height - sticky.offsetHeight;
    target = travel > 0 ? clamp((top - rect.top) / travel) : 0;
  };
  // From step 02 the pack sways gently left and right, rattles while it is torn,
  // pops up when the jersey comes out and stands upright again at the end.
  const move = (tear, rise) => {
    const sway = clamp((shown - .3) / .62);
    const x = Math.sin(tear * Math.PI * 9) * Math.sin(tear * Math.PI) * 6;
    // On phones the step text below is taller in step 3 (with the button), so the pack moves up instead of down.
    const y = narrow.matches ? rise * -24 : rise * 40;
    const tilt = Math.sin(sway * Math.PI * 2) * 4;
    // the pack shrinks as the jersey comes out so the shirt has room above it
    const scale = .92 + tear * .04 - rise * .2;
    const t = `translate3d(${x.toFixed(1)}px,${y.toFixed(1)}px,0) rotate(${tilt.toFixed(2)}deg) scale(${scale.toFixed(4)})`;
    visual.style.transform = t;
    badges.style.transform = narrow.matches ? `translateX(-50%) ${t}` : t;
  };
  const render = () => {
    const tear = tearAt(shown), rise = riseAt(shown);
    move(tear, rise);
    root.style.setProperty('--p', shown.toFixed(4));
    root.style.setProperty('--tear', tear.toFixed(4));
    root.style.setProperty('--rise', rise.toFixed(4));
    const intro = shown < .3;
    root.classList.toggle('is-intro', intro);
    if (intro) openBox(introAt(shown));
    draw(frameAt(shown));
    const next = shown < .3 ? 0 : shown < .66 ? 1 : 2;
    if (next !== step) {
      step = next;
      steps.forEach((el, i) => el.classList.toggle('is-active', i === step));
      root.dataset.step = String(step);
    }
  };
  // A short easing between scroll position and picture keeps the tear smooth.
  const tick = () => {
    measure();
    shown += (target - shown) * .2;
    if (Math.abs(target - shown) < .0005) shown = target;
    render();
    if (running) requestAnimationFrame(tick);
  };
  new IntersectionObserver(([entry]) => {
    if (entry.isIntersecting) {
      load();
      if (!running) { running = true; requestAnimationFrame(tick); }
    } else running = false;
  }, {rootMargin: '60% 0px'}).observe(root);
  measure();
  shown = target;
  render();
})();
